<template>
  <v-app id="inspire" class="bodyPadding"> 
    <mo-header></mo-header>
    <v-content>
		<install-head></install-head>		
		<install-list></install-list>
    </v-content>
  </v-app>
</template>

<script>

	import InstallHead from './Header.vue';	
	import InstallList from './List.vue';

	export default {
		data () {
			return {
		
			}		
		},
		components: {
            InstallHead,			
			InstallList
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>